<div class="text-gray-100 text-10">
  <ng-container *ngIf="uploadsLeftAmount !== 0">
    {{ uploadsLeftAmount }}&nbsp;
    <span class="opacity-50"
      >{{ headerTitle1 }}&nbsp;{{ uploadsAmount }}&nbsp;{{ headerTitle2 }}</span
    ></ng-container
  >
  <ng-container *ngIf="uploadsLeftAmount === 0">
    {{ 'view.patient.resources.upload.progress.all-loaded' | transloco }}
  </ng-container>
</div>
<div class="flex justify-end items-center">
  <button class="w-24 h-24">
    <tdv-icon
      [name]="!isFullView ? 'chevron-down' : 'chevron-up'"
      class="icon-gray w-24 h-24"
    ></tdv-icon>
  </button>
</div>
